import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import ApiService from "../../../config/api";

const AboutUs = () => {
  const [founders, setFounders] = useState([]);
  const [loading, setLoading] = useState(true);


  const fetchFounders = async () => {
    try {
      const res = await ApiService.get("user/founders");
      if (!res.data.error) {
        setFounders(res.data.meta);
      }
    } catch (err) {
      console.error("Error fetching founders:", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchFounders();
  }, []);

  const SkeletonCard = () => (
    <div
      className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch"
      style={{ animation: "pulse 1.5s infinite" }}
    >
      <div
        className="w-100"
        style={{
          borderRadius: "20px",
          overflow: "hidden",
          background: "rgba(255,255,255,0.08)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.15)",
          padding: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "320px",
            height: "300px",
            background: "rgba(255,255,255,0.2)",
            borderRadius: "12px",
            margin: "0 auto 20px",
          }}
        ></div>
        <div
          style={{
            width: "60%",
            height: "18px",
            background: "rgba(255,255,255,0.2)",
            borderRadius: "6px",
            margin: "0 auto 10px",
          }}
        ></div>
        <div
          style={{
            width: "80%",
            height: "14px",
            background: "rgba(255,255,255,0.2)",
            borderRadius: "6px",
            margin: "0 auto",
          }}
        ></div>
      </div>
    </div>
  );


  return (
    <>
      <Navbar />

      <div className="pagecolor">
        <div className="heroes min-vh-100 d-flex align-items-center">
          <div className="container">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-lg-12 col-md-12 mb-3 d-flex justify-content-center">
                    <img
                      src="\assets\images\buyPageImg\butterfly-house-martis-camp-united-states-2-1024x683.webp"
                      alt="Top Image"
                      className="img-fluid custom-image "
                      style={{
                        width: "600px",
                        height: "auto",
                        borderRadius: "30px",
                        marginTop: "50px",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 hero-text-about d-flex justify-content-center align-items-center">
                <div>
                  <h3
                    className="m-4"
                    style={{
                      color: "var(--bs-accent)",
                      fontFamily: "Bahnschrift SemiBold",
                      fontWeight: "bold",
                    }}
                  >
                    About Us
                  </h3>
                  <p
                    className="contant"
                    style={{
                      color: " var(--bs-secondary)",
                      fontSize: "16px",
                    }}
                  >
                    <span style={{ fontWeight: 'bold' }}>Eleganza Estate Solutions</span> is your trusted partner for <span style={{ fontWeight: 'bold' }}>real estate in Bhopal</span> ,
                    specialising in   <span style={{ fontWeight: 'bold' }}>Premium properties in Bhopal</span> with a Zero Brokerage Policy so
                    you pay no commission fees. We simplify property buying with transparent deals,
                    expert property legal consultancy in Bhopal, and a hassle-free process for luxury
                    apartments, villas, and plots. Discover a smarter way to invest in <span style={{ fontWeight: 'bold' }}>zero brokerage
                      real estate in Bhopal today.</span>

                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="container reviews">

          <div className="row justify-content-center">
            <h3
              className="contantheading"
              style={{
                color: "var(--bs-accent)",
                fontFamily: "Bahnschrift, sans-serif",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Our Founders
            </h3>
            <p
              className="text-center contant"
              style={{
                color: "var(--bs-secondary)",
                fontSize: "1rem",
              }}
            >
              Eleganza was established by three visionaries who share a passion for innovation and excellence in real estate:
            </p>

            <div className="row">
              {loading
                ? Array(3).fill().map((_, i) => <SkeletonCard key={i} />)
                : founders.map((founder) => (
                  <div className="col-lg-4 col-md-6 mb-4 d-flex align-items-stretch" key={founder.id}>
                    <div
                      className="position-relative w-100"
                      style={{
                        borderRadius: "20px",
                        overflow: "hidden",
                        background: "rgba(255, 255, 255, 0.08)",
                        backdropFilter: "blur(12px)",
                        border: "1px solid rgba(255, 255, 255, 0.15)",
                        boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
                        transition: "all 0.35s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px) scale(1.02)";
                        e.currentTarget.style.boxShadow = "0 12px 40px rgba(0,0,0,0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0) scale(1)";
                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.12)";
                      }}
                    >
                      <div
                        className="position-absolute w-100"
                        style={{
                          height: "5px",
                          top: 0,
                          left: 0,
                          background: "linear-gradient(90deg, #F4EBD0 0%, #D6AD60 100%)",
                        }}
                      ></div>

                      <div className="p-4 text-center d-flex flex-column align-items-center">
                        <div className="mb-3 position-relative">
                          <img
                            src={founder.image}
                            alt={founder.name}
                            className="rounded w-100"
                            style={{
                              maxWidth: "320px",
                              height: "300px",
                              objectFit: "cover",
                              border: "2px solid rgba(255,255,255,0.6)",
                              boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                            }}
                          />
                        </div>


                        <h5
                          style={{
                            fontWeight: "700",
                            fontSize: "1.2rem",
                            color: "var( --bs-accent)",
                            marginBottom: "6px",
                          }}
                        >
                          {founder.name}
                        </h5>

                        <p
                          style={{
                            fontSize: "0.9rem",
                            color: "rgba(255,255,255,0.85)",
                            lineHeight: "1.6",
                            textAlign: "center",
                          }}
                        >
                          {founder.description}
                        </p>

                      </div>
                    </div>
                  </div>
                ))}
            </div>

            <p
              className="text-center contant"
              style={{
                color: "var(--bs-secondary)",
                fontSize: "1rem",
                lineHeight: "1.8",
                marginTop: "2rem",
                marginBottom: "3rem",
              }}
            >
              Together, they recognized an opportunity to offer premium properties without the burden of high brokerage fees. Eleganza was their solution: a platform providing exclusive, high-end properties with no hidden costs, ensuring a seamless and transparent experience for buyers.
            </p>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 hero-text-about" style={{ alignContent: "center" }}>
                <div
                  style={{
                    color: "var(--bs-secondary)",
                    fontSize: "16px",
                  }}
                >
                  <h5 style={{ fontWeight: "bold", marginTop: "20px", color: "var(--bs-accent)" }}>Our Services and Reach</h5>
                  <p style={{ fontSize: '16px' }}>
                    At Eleganza Estate Solutions, we handpick luxury apartments, elegant villas,
                    spacious plots, and high-value commercial properties in and around Bhopal. Our
                    curated real estate portfolio caters to those who value timeless elegance and smart
                    investments. While Bhopal is where we started, our vision is to establish Eleganza
                    as a global leader in the premium real estate market.
                  </p>

                  <h5 style={{ fontWeight: "bold", marginTop: "20px", color: "var(--bs-accent)" }}>Zero Brokerage, Maximum Value</h5>
                  <p style={{ fontSize: '16px' }}>
                    Eleganza’s Zero Brokerage Policy ensures buyers pay no extra fees. This
                    commitment to transparency makes the real estate buying journey smoother, more
                    accessible, and stress-free. No fees, no hidden costs—just exceptional service and
                    premium properties.                  </p>

                  <h5 style={{ fontWeight: "bold", marginTop: "20px", color: "var(--bs-accent)" }}>Eleganza’s Commitment to Diversity</h5>
                  <p style={{ fontSize: '16px' }}>
                    We go beyond residential spaces, offering prime plots and premium commercial
                    properties, ensuring our buyers have access to a wide variety of high-value real
                    estate opportunities in Bhopal and beyond.                  </p>

                  <h5 style={{ fontWeight: "bold", marginTop: "20px", color: "var(--bs-accent)" }}>Looking Ahead</h5>
                  <p style={{ fontSize: '16px' }}>
                    Eleganza isn’t just about selling real estate; it’s about redefining how buyers and
                    investors access premium properties. Whether you’re a first-time homebuyer or a
                    seasoned investor, we’re here to provide unmatched value, transparency, and
                    elegance—all under one roof.
                  </p>

                  <blockquote className="text-center" style={{ fontSize: '16px', fontStyle: 'italic', marginTop: '30px' }}>
                    "More than a real estate firm, it’s your gateway to timeless elegance and timeless investment."
                  </blockquote>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;